export default __webpack_public_path__ + "static/media/trash-secondary.d264ae22.svg";